import React from 'react';
import { Modal, Spin, Button, Result, Typography, List } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * ProcessingModal: Displays the status of the external image validation process.
 * * @param {boolean} isVisible - Controls the modal's open/close state.
 * @param {boolean} isLoading - Shows the loading spinner when true.
 * @param {string[]} errors - Array of rejection reasons. Empty array means success.
 * @param {function} onClose - Function to close the modal.
 */
const PhotoProcessingModal = ({ isVisible, isLoading, errors, onClose }) => {
    
    // Determine the final status based on props
    const isApproved = isVisible && !isLoading && errors && errors.length === 0;
    const isRejected = isVisible && !isLoading && errors && errors.length > 0;
    
    let title = "";
    let status = "info"; // Default AntD status for loading
    
    if (isLoading) {
        title = "Processing Photo";
    } else if (isApproved) {
        title = "Validation Successful";
        status = "success";
    } else if (isRejected) {
        title = "Validation Failed";
        status = "error";
    }

    // --- Modal Content Rendering ---
    const renderModalContent = () => {
        if (isLoading) {
            return (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <Spin size="large" tip="Analyzing photo requirements..."/>
                    <p style={{ marginTop: '20px' }}>Please wait while we check your photo compliance.</p>
                </div>
            );
        }

        if (isApproved) {
            return (
                <Result
                    status={status}
                    title={title}
                    subTitle="Your photo meets all requirements."
                    extra={<Button type="primary" onClick={onClose}>Continue</Button>}
                />
            );
        }

        if (isRejected) {
            return (
                <Result
                    status={status}
                    title={title}
                    subTitle="The image failed to meet one or more required criteria."
                    extra={<Button type="primary" onClick={onClose}>Close</Button>}
                >
                    <div className="desc" style={{ textAlign: 'left', padding: '0 0px' }}>
                        <Text strong>Reasons for Rejection:</Text>
                        <List
                            size="small"
                            style={{width : "100%"}}
                            bordered
                            dataSource={errors}
                            renderItem={item => <List.Item><Text type="danger">{item}</Text></List.Item>}
                        />
                    </div>
                </Result>
            );
        }
        return null;
    };

    return (
        <Modal
            title={title}
            visible={isVisible}
            footer={null}
            closable={!isLoading}
            onCancel={onClose}
            width={500}
            centered
        >
            {renderModalContent()}
        </Modal>
    );
};

export default PhotoProcessingModal;